import { create } from 'zustand';
import { chatService } from '../services/chat/chat.service';
import { webSocketService } from '../services/websocket/websocket.service';

interface ChatNotificationsState {
  totalNoLeidos: number;
  setTotalNoLeidos: (total: number) => void;
  refreshStats: () => Promise<void>;
}

export const useChatNotificationsStore = create<ChatNotificationsState>((set) => {
  // Singleton listener para mensajes de chat
  const handleChatMessage = () => {
    set((state) => ({
      totalNoLeidos: state.totalNoLeidos + 1,
    }));
  };

  webSocketService.addChatMessageListener(handleChatMessage);

  const refresh = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token || token === 'undefined' || token === 'null') return;

    try {
      const result = await chatService.contarNoLeidos();
      set({ totalNoLeidos: result.total });
    } catch (error) {
      console.error('Error fetching chat unread count:', error);
    }
  };

  refresh();
  const intervalId = setInterval(refresh, 30000);

  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      clearInterval(intervalId);
      webSocketService.removeChatMessageListener(handleChatMessage);
    });
  }

  return {
    totalNoLeidos: 0,
    setTotalNoLeidos: (total) => set({ totalNoLeidos: total }),
    refreshStats: refresh,
  };
});
